import { Route, Routes } from "react-router-dom"
import NotFoundPage from "@/views/404/NotFoundPage"
import Logout from "@/views/auth/Logout"
import Home from "@/views/home/Home"
import Setting from "@/views/setting/Setting"
import { Dashboard } from "@/constants/lazyLoad/lazyMain"
import { Suspense } from "react"
import { CircularProgress } from "@mui/material"
import ClientsRoutes from "./ClientsRoutes"
import { Abonnements } from "@/constants/lazyLoad/lazyAbonnements"
import { FonctionnalitiesAndAddOn } from "@/constants/lazyLoad/lazyFonctionnalitiesAndAddOn"
import { LogsSystem } from "@/constants/lazyLoad/lazyLogsSystem"
import { CodePromo } from "@/constants/lazyLoad/lazyCodePromo"
import { Roles } from "@/constants/lazyLoad/lazyRoles"
import Transactions from "@/views/transactions/Transactions"
import OffersRoutes from "@/routes/OffersRoutes"
import { Facturation } from "@/constants/lazyLoad/lazyFacturation"
import { CustomerSupports } from "@/constants/lazyLoad/lazyCustomerSupports"
import AddOrModifyInvoice from "@/views/facturation/AddOrModifyInvoice"
import Loader from "components/common/Loader"
import Income from "@/views/income/Income"
const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Home />}>
          <Route index element={<Dashboard />} />
          <Route path="clients/*" element={<ClientsRoutes />} />
          <Route path="/abonnements" element={<Abonnements />} />
          {/*<Route path="/transactions" element={<Transactions />}>*/}
          {/*  <Route index element={<TransactionDataTable />} />*/}
          {/*  <Route path={`account-recharge`} element={< AccountRecharge/>}/>*/}
          {/*  </Route>*/}
          <Route path="/transactions/*" element={<Transactions />} />

          <Route path="offres/*" element={<OffersRoutes />}/>
          <Route path="/fonctionnalites-et-add-on" element={<FonctionnalitiesAndAddOn />} />
          <Route path="/logs-system" element={<LogsSystem />} />
          <Route path="/code-promo" element={<CodePromo />} />
          <Route path="/facturation" >
            <Route index element={<Facturation />} />
            <Route path="ajout-facture" element={<AddOrModifyInvoice />} />
          </Route>
          <Route path="/supports-clients" element={<CustomerSupports />} />
          <Route path="revenues" element={<Income />}/>
          {/*<Route path="/offres" element={<Offers />} />*/}
          {/*<Route path="/paiements" element={<Payments />} />*/}
          {/*<Route path="/membres-du-support" element={<SupportMembers />} />*/}
          {/*<Route path="/factures" element={<Invoices />} />*/}
          {/*<Route path="/activites" element={<Activity />} />*/}
          {/*<Route path="/affectations-closes" element={<ClosedAssignment />} />*/}
          {/*<Route path="/rapports-statistiques" element={<StatisticalReport />} />*/}
          <Route path="/roles" element={<Roles />} />
          <Route path="/parametres" element={<Setting />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
